import { Card, CardHeader, Typography, Button, CircularProgress, CardContent, Divider, Grid, Stack, Box } from "@mui/material";
import { FC, useState } from "react";
import { GreenJobs, YellowJobs, RedJobs } from "../dashboard/statusBadge";
import ArrowRightIcon from '~/icons/ArrowRight';
import AddIcon from '@mui/icons-material/Add';
import NavigationRefresh from '@mui/icons-material/Refresh';
import { useShowContext, ReduxState, useRefresh } from "ra-core";
import { useSelector } from "react-redux";
import { RecPatch } from "~/dataProvider/tools";
import { Link as RouterLink } from 'react-router-dom'
import { AlertAndTime } from "~/gen/api/encrypt";


export interface PerformanceDashboardResponseDto {
  performanceSuccessCount: number;
  performanceWarningCount: number;
  performanceFailedCount: number;
  performanceAlerts: AlertAndTime[];
}


const PerformanceStatusCard: FC = () => {
  const { record } = useShowContext<PerformanceDashboardResponseDto & RecPatch>()
  const loading = useSelector<ReduxState>(state => state.admin.loading > 0);
  const refresh = useRefresh()

  const [open, setOpen] = useState(false)

  return (
    <Card>
      <CardHeader 
        sx={{ pb: 0 }}
        title={(
          <Typography variant="h6" color="textPrimary">
            Performance Status
          </Typography>
        )}
        action={(
          <Button
            size="small"
            startIcon={loading ?<CircularProgress size={14} /> : <NavigationRefresh />}
            color="secondary"
            onClick={() => refresh()}
          >
            Refresh
          </Button>)}
      />
      <CardContent>
        <Divider sx={{ mb: 1 }} />
        <Grid container direction="row" sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <Typography
              color="textSecondary"
              variant="overline"
            >
              Databases
            </Typography>
            <Stack 
              direction="column"
              sx={{ 
                mt: 2,
                mb: 1,
              }}
            >
              <GreenJobs count={record?.performanceSuccessCount || 0} />
              <YellowJobs count={record?.performanceWarningCount || 0} />
              <RedJobs count={record?.performanceFailedCount || 0} />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                mt: 4,
                alignItems: 'normal',
                display: 'flex',
                flexDirection: 'column',
                '& .MuiButton-root': {
                  mb: 1.5,
                },
              }}
            >
              <Button
                disabled={true}
                color="primary"
                startIcon={<AddIcon fontSize="small" />}
                variant="outlined"
                onClick={() => setOpen(true)}
              >
                Performances Analysis
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default PerformanceStatusCard;
